var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amap"},[_c('div',{staticClass:"clod",on:{"click":function($event){return _vm.close()}}},[_vm._v(" × ")]),_c('div',{attrs:{"id":"mapContainer"}})])}
var staticRenderFns = []

export { render, staticRenderFns }